import { useState } from 'react';
import { mockAIImage, GALLERY_SIZE } from '../../utils/mockImages';
import { showToast } from '../../store/useToastStore';
import Spinner from './Spinner';

/* Suggested-image gallery + upload + "Generate with AI".
   Pass `suggestions` (array of image URLs) + `onGenerate` to drive the gallery
   externally — the button then triggers the caller's fetch (e.g. Unsplash by
   event title) and `suggestionsLoading` shows its progress. When those props are
   omitted, the prototype's mock gallery/generate behavior is used. */
export default function ImageGalleryPicker({ image, onChange, suggestions, suggestionsLoading, onGenerate }) {
  const [generating, setGenerating] = useState(false);

  const thumbs =
    suggestions !== undefined ? suggestions : Array.from({ length: GALLERY_SIZE }, (_, i) => mockAIImage(i));
  const busy = onGenerate ? !!suggestionsLoading : generating;

  const handleUpload = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    /* second arg = the raw File, for callers that upload it to an API */
    reader.onload = (ev) => onChange(ev.target.result, file);
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const handleGenerate = () => {
    if (onGenerate) {
      onGenerate();
      return;
    }
    setGenerating(true);
    setTimeout(() => {
      onChange(mockAIImage(Math.floor(Math.random() * GALLERY_SIZE)));
      setGenerating(false);
      showToast('Image generated ✓');
    }, 900);
  };

  return (
    <>
      {thumbs.length > 0 && (
        <div className="image-gallery">
          {thumbs.map((src, i) => (
            <img
              key={src + i}
              src={src}
              alt="Suggested"
              title="Suggested image"
              className={`gallery-thumb ${image === src ? 'sel' : ''}`}
              onClick={() => onChange(src)}
            />
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <label className="file-chip">
          <img src="/assets/icons/upload.svg" alt="" />Upload photo
          <input type="file" accept="image/*" onChange={handleUpload} />
        </label>
        <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={handleGenerate}>
          {busy ? (
            <><Spinner variant="green" /> Generating…</>
          ) : (
            <><img className="btn-icon-img" src="/assets/icons/ai.svg" alt="" />Generate image</>
          )}
        </button>
      </div>
    </>
  );
}
